const credentials = {
  client_id: '8026dc8b6b214131b53d4c1b5d26382a',
  redirect_uri: 'https://sanitizemusic.com/callback',
  frontend_url: 'https://sanitizemusic.com',
  backend_url: 'https://sanitizemusic.com'
};

module.exports = credentials;
